import { VoyageRoute, VoyageRoutePointFeature } from "../../models/voyage-routing-model";
import { WhaleZonesModel } from "../../models/whale-zones-model";
import { RouteGeometry } from '../../models/voyage-routing-model';
import { ZoneFeature } from "../../models/zones-base-interfaces";
import { ZonesUtilitiesBase } from "./zones-utilities-base";

export class WhaleZonesUtilities extends ZonesUtilitiesBase {
    zoneID: string = "WHALE ZONE"
    zoneStoreType: string = "WHALE"
    
    async getZones(route?: RouteGeometry): Promise<ZoneFeature[]> {
        const zones = await WhaleZonesModel!.allActiveZones(new Date(route![0].properties.timestamp!), new Date(route![route!.length - 1].properties.timestamp!));
        if (!zones) {
            throw new Error("Could not retreive Whale Zones.");
        }

        return zones;
    }

    // Used by the pre-v2 "Apply whale zones" route action, which stamps the speed limits onto the
    // waypoints in the browser. With const_pow_endpoint_v2 enabled the restrictions come from the
    // analytics constant-power calculation instead and this path is not reached — see
    // voyage-suggested-routes._disableWhaleZoneSpeedRestrictions.
    setAppliedFlagOnRoute(route: VoyageRoute): void {
        route.route_info!.whaleZonesApplied = true;
    }

    modifyWaypointProperties(waypoint: VoyageRoutePointFeature, zones: ZoneFeature[]): void {
        const speed = Math.min(...zones.map(z => {
            const speedLimit = z.properties?.[0]?.maxSOG;
            return (speedLimit ?? 0) / (60*60 / 1852)
        }));
        waypoint.properties.speed_maximum ? waypoint.properties.speed_maximum = Math.min(waypoint.properties.speed_maximum, speed) : waypoint.properties.speed_maximum = speed;
    }
}
